import { render, staticRenderFns } from "./XtendStatisticTable.vue?vue&type=template&id=44ad5259&"
import script from "./XtendStatisticTable.vue?vue&type=script&lang=js&"
export * from "./XtendStatisticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports